// Full UI translations. Department names remain in Devanagari always.
export const TRANSLATIONS = {
  en: {
    // Sidebar / nav
    "nav.dashboard": "Dashboard",
    "nav.complaints": "All Complaints",
    "nav.new": "New Complaint",
    "nav.departments": "Departments",
    "nav.search": "Track by Mobile",
    "nav.settings": "Settings",
    "brand.title": "Complaint Portal",
    "brand.subtitle": "Office of RSB",
    "auth.signed_in": "Signed in",
    "auth.logout": "Log out",
    "auth.role.admin": "ADMIN",
    "auth.role.officer": "OFFICER",
    "auth.role.user": "USER",

    // Common
    "common.save": "Save changes",
    "common.cancel": "Cancel",
    "common.saving": "Saving...",
    "common.back": "Back",
    "common.loading": "Loading...",
    "common.confirm": "Confirm",
    "common.delete": "Delete",
    "common.close": "Close",
    "common.open": "Open",
    "common.edit": "Edit",
    "common.enable": "Enable",
    "common.disable": "Disable",

    // Dashboard
    "dash.overview": "Overview",
    "dash.title": "Complaint Dashboard",
    "dash.subtitle": "Real-time overview of citizen grievances across all departments.",
    "dash.new_btn": "Register New Complaint",
    "dash.total": "Total Complaints",
    "dash.open": "Open",
    "dash.closed": "Closed",
    "dash.today": "Today",
    "dash.overdue": "Overdue",
    "dash.departments": "Departments",
    "dash.stages": "Lifecycle Stages",
    "dash.recent": "Recently Updated",
    "dash.dept_volume": "Department-wise Volume",
    "dash.dept_click_hint": "Click a department to filter its complaints.",
    "dash.stage_dist": "Stage Distribution",
    "dash.stage_hint": "Complaints by current lifecycle stage.",
    "dash.recent_hint": "Latest complaint status & stage changes.",
    "dash.view_all": "View all →",
    "dash.all_time": "All time",
    "dash.active": "Active cases",
    "dash.resolved": "Resolved & archived",
    "dash.filed_today": "Filed today",
    "dash.past_action": "Past next-action date",
    "dash.service_lines": "Active service lines",
    "dash.in_use": "In active use",
    "dash.last_5": "Last 5 changes",

    // Settings
    "settings.title": "Settings",
    "settings.subtitle": "Manage your account, preferences, security and system information.",
    "settings.nav.appearance": "Appearance",
    "settings.nav.language": "Language",
    "settings.nav.profile": "Profile",
    "settings.nav.notifications": "Notifications",
    "settings.nav.preferences": "Preferences",
    "settings.nav.security": "Security",
    "settings.nav.sessions": "Active Sessions",
    "settings.nav.system": "System Info",
    "settings.appearance.title": "Appearance",
    "settings.appearance.desc": "Choose how the interface looks. Changes apply instantly and persist across devices.",
    "settings.theme.light": "Light",
    "settings.theme.dark": "Dark",
    "settings.theme.system": "System",
    "settings.language.title": "Language",
    "settings.language.desc": "Switch the UI language. Department names remain in Hindi as per official records.",
    "settings.profile.title": "Profile",
    "settings.profile.desc": "Personal information used across the platform.",
    "settings.profile.avatar": "Profile picture",
    "settings.profile.avatar_hint": "PNG or JPG. Recommended 512x512.",
    "settings.profile.upload": "Upload",
    "settings.profile.remove": "Remove",
    "settings.profile.name": "Full name",
    "settings.profile.email": "Email",
    "settings.profile.mobile": "Mobile number",
    "settings.notify.title": "Notifications",
    "settings.notify.desc": "Control how the system contacts you about complaint updates.",
    "settings.notify.email": "Email notifications",
    "settings.notify.email_hint": "Weekly digest and per-complaint updates.",
    "settings.notify.sms": "SMS notifications",
    "settings.notify.sms_hint": "Real-time SMS on stage changes.",
    "settings.notify.in_app": "In-app notifications",
    "settings.notify.in_app_hint": "Bell alerts inside the dashboard.",
    "settings.prefs.title": "Application preferences",
    "settings.prefs.desc": "Personalise defaults across the app.",
    "settings.prefs.dashboard_view": "Default dashboard view",
    "settings.prefs.landing": "Default landing page",
    "settings.prefs.date": "Date format",
    "settings.prefs.time": "Time format",
    "settings.prefs.tz": "Time zone",
    "settings.security.title": "Security",
    "settings.security.desc": "Protect your account with a strong password and two-factor authentication.",
    "settings.security.change_pw": "Change password",
    "settings.security.current_pw": "Current password",
    "settings.security.new_pw": "New password",
    "settings.security.confirm_pw": "Confirm new password",
    "settings.security.update_pw": "Update password",
    "settings.security.2fa": "Two-Factor Authentication",
    "settings.security.2fa_hint": "Require a 6-digit code from your authenticator app on every login.",
    "settings.security.2fa_enable": "Enable 2FA",
    "settings.security.2fa_disable": "Disable 2FA",
    "settings.security.2fa_verify": "Verify code",
    "settings.security.2fa_step_scan": "Scan this QR with Google Authenticator, Authy or 1Password.",
    "settings.security.2fa_step_verify": "Enter the 6-digit code shown in the app to enable 2FA.",
    "settings.sessions.title": "Active sessions",
    "settings.sessions.desc": "Devices currently signed in with your account.",
    "settings.sessions.current": "This device",
    "settings.sessions.revoke": "Revoke",
    "settings.sessions.logout_others": "Log out other sessions",
    "settings.sessions.logout_all": "Log out from all devices",
    "settings.system.title": "System information",
    "settings.system.desc": "Environment details useful when reporting an issue.",
    "settings.system.version": "Application version",
    "settings.system.role": "User role",
    "settings.system.last_login": "Last login",
    "settings.system.ip": "Last IP address",
    "settings.system.device": "Device / browser",
    "settings.system.server_time": "Server time (UTC)",
    "settings.saved": "Settings saved",
    "settings.error": "Could not save settings",
  },
  hi: {
    "nav.dashboard": "डैशबोर्ड",
    "nav.complaints": "सभी शिकायतें",
    "nav.new": "नई शिकायत",
    "nav.departments": "विभाग",
    "nav.search": "मोबाइल से खोजें",
    "nav.settings": "सेटिंग्स",
    "brand.title": "शिकायत पोर्टल",
    "brand.subtitle": "राजस्थान सरकार",
    "auth.signed_in": "साइन इन",
    "auth.logout": "लॉग आउट",
    "auth.role.admin": "प्रशासक",
    "auth.role.officer": "अधिकारी",
    "auth.role.user": "उपयोगकर्ता",

    "common.save": "बदलाव सहेजें",
    "common.cancel": "रद्द करें",
    "common.saving": "सहेज रहा है...",
    "common.back": "वापस",
    "common.loading": "लोड हो रहा है...",
    "common.confirm": "पुष्टि करें",
    "common.delete": "हटाएँ",
    "common.close": "बंद करें",
    "common.open": "खोलें",
    "common.edit": "संपादित करें",
    "common.enable": "सक्षम करें",
    "common.disable": "अक्षम करें",

    "dash.overview": "अवलोकन",
    "dash.title": "शिकायत डैशबोर्ड",
    "dash.subtitle": "सभी विभागों में नागरिक शिकायतों का वास्तविक समय अवलोकन।",
    "dash.new_btn": "नई शिकायत दर्ज करें",
    "dash.total": "कुल शिकायतें",
    "dash.open": "खुली",
    "dash.closed": "बंद",
    "dash.today": "आज",
    "dash.overdue": "अतिदेय",
    "dash.departments": "विभाग",
    "dash.stages": "जीवनचक्र चरण",
    "dash.recent": "हाल ही में अद्यतन",
    "dash.dept_volume": "विभाग-वार शिकायतें",
    "dash.dept_click_hint": "किसी विभाग पर क्लिक करके फ़िल्टर करें।",
    "dash.stage_dist": "चरण वितरण",
    "dash.stage_hint": "वर्तमान जीवनचक्र चरण के अनुसार शिकायतें।",
    "dash.recent_hint": "नवीनतम स्थिति और चरण परिवर्तन।",
    "dash.view_all": "सभी देखें →",
    "dash.all_time": "अब तक",
    "dash.active": "सक्रिय मामले",
    "dash.resolved": "समाधान और संग्रहीत",
    "dash.filed_today": "आज दर्ज",
    "dash.past_action": "अगली कार्रवाई तिथि पार",
    "dash.service_lines": "सक्रिय सेवा लाइनें",
    "dash.in_use": "सक्रिय उपयोग में",
    "dash.last_5": "अंतिम 5 बदलाव",

    "settings.title": "सेटिंग्स",
    "settings.subtitle": "अपना खाता, प्राथमिकताएँ, सुरक्षा और सिस्टम जानकारी प्रबंधित करें।",
    "settings.nav.appearance": "उपस्थिति",
    "settings.nav.language": "भाषा",
    "settings.nav.profile": "प्रोफ़ाइल",
    "settings.nav.notifications": "सूचनाएँ",
    "settings.nav.preferences": "प्राथमिकताएँ",
    "settings.nav.security": "सुरक्षा",
    "settings.nav.sessions": "सक्रिय सत्र",
    "settings.nav.system": "सिस्टम जानकारी",
    "settings.appearance.title": "उपस्थिति",
    "settings.appearance.desc": "इंटरफ़ेस की उपस्थिति चुनें। परिवर्तन तुरंत लागू होते हैं और डिवाइस पर बने रहते हैं।",
    "settings.theme.light": "लाइट",
    "settings.theme.dark": "डार्क",
    "settings.theme.system": "सिस्टम",
    "settings.language.title": "भाषा",
    "settings.language.desc": "UI भाषा बदलें। आधिकारिक रिकॉर्ड के अनुसार विभाग के नाम हिन्दी में रहेंगे।",
    "settings.profile.title": "प्रोफ़ाइल",
    "settings.profile.desc": "पूरे प्लेटफ़ॉर्म पर उपयोग होने वाली व्यक्तिगत जानकारी।",
    "settings.profile.avatar": "प्रोफ़ाइल चित्र",
    "settings.profile.avatar_hint": "PNG या JPG। अनुशंसित 512x512।",
    "settings.profile.upload": "अपलोड करें",
    "settings.profile.remove": "हटाएँ",
    "settings.profile.name": "पूरा नाम",
    "settings.profile.email": "ईमेल",
    "settings.profile.mobile": "मोबाइल नंबर",
    "settings.notify.title": "सूचनाएँ",
    "settings.notify.desc": "सिस्टम आपसे शिकायत अपडेट के बारे में कैसे संपर्क करता है, यह नियंत्रित करें।",
    "settings.notify.email": "ईमेल सूचनाएँ",
    "settings.notify.email_hint": "साप्ताहिक सारांश और प्रति-शिकायत अद्यतन।",
    "settings.notify.sms": "एसएमएस सूचनाएँ",
    "settings.notify.sms_hint": "चरण परिवर्तन पर वास्तविक समय एसएमएस।",
    "settings.notify.in_app": "इन-ऐप सूचनाएँ",
    "settings.notify.in_app_hint": "डैशबोर्ड के अंदर घंटी अलर्ट।",
    "settings.prefs.title": "एप्लिकेशन प्राथमिकताएँ",
    "settings.prefs.desc": "ऐप में डिफ़ॉल्ट सेटिंग्स को वैयक्तिकृत करें।",
    "settings.prefs.dashboard_view": "डिफ़ॉल्ट डैशबोर्ड दृश्य",
    "settings.prefs.landing": "डिफ़ॉल्ट लैंडिंग पृष्ठ",
    "settings.prefs.date": "तिथि प्रारूप",
    "settings.prefs.time": "समय प्रारूप",
    "settings.prefs.tz": "समय क्षेत्र",
    "settings.security.title": "सुरक्षा",
    "settings.security.desc": "मजबूत पासवर्ड और दो-कारक प्रमाणीकरण से अपने खाते की सुरक्षा करें।",
    "settings.security.change_pw": "पासवर्ड बदलें",
    "settings.security.current_pw": "वर्तमान पासवर्ड",
    "settings.security.new_pw": "नया पासवर्ड",
    "settings.security.confirm_pw": "नए पासवर्ड की पुष्टि करें",
    "settings.security.update_pw": "पासवर्ड अपडेट करें",
    "settings.security.2fa": "दो-कारक प्रमाणीकरण",
    "settings.security.2fa_hint": "हर लॉगिन पर अपने ऑथेंटिकेटर ऐप से 6-अंकीय कोड की आवश्यकता होगी।",
    "settings.security.2fa_enable": "2FA सक्षम करें",
    "settings.security.2fa_disable": "2FA अक्षम करें",
    "settings.security.2fa_verify": "कोड सत्यापित करें",
    "settings.security.2fa_step_scan": "इस QR को Google Authenticator, Authy या 1Password से स्कैन करें।",
    "settings.security.2fa_step_verify": "2FA सक्षम करने के लिए ऐप में दिखाया गया 6-अंकीय कोड दर्ज करें।",
    "settings.sessions.title": "सक्रिय सत्र",
    "settings.sessions.desc": "इस समय आपके खाते से लॉग इन डिवाइस।",
    "settings.sessions.current": "यह डिवाइस",
    "settings.sessions.revoke": "समाप्त करें",
    "settings.sessions.logout_others": "अन्य सत्रों से लॉग आउट",
    "settings.sessions.logout_all": "सभी डिवाइस से लॉग आउट",
    "settings.system.title": "सिस्टम जानकारी",
    "settings.system.desc": "समस्या रिपोर्ट करते समय उपयोगी विवरण।",
    "settings.system.version": "एप्लिकेशन संस्करण",
    "settings.system.role": "उपयोगकर्ता भूमिका",
    "settings.system.last_login": "अंतिम लॉगिन",
    "settings.system.ip": "अंतिम IP पता",
    "settings.system.device": "डिवाइस / ब्राउज़र",
    "settings.system.server_time": "सर्वर समय (UTC)",
    "settings.saved": "सेटिंग्स सहेजी गईं",
    "settings.error": "सेटिंग्स सहेजने में विफल",
  },
};
